/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupForUserBackendInfo
 */
export interface UserGroupForUserBackendInfo {
    /**
     * 
     * @type {string}
     * @memberof UserGroupForUserBackendInfo
     */
    name: string;
}

export function UserGroupForUserBackendInfoFromJSON(json: any): UserGroupForUserBackendInfo {
    return UserGroupForUserBackendInfoFromJSONTyped(json, false);
}

export function UserGroupForUserBackendInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupForUserBackendInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UserGroupForUserBackendInfoToJSON(value?: UserGroupForUserBackendInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


